import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { formatCurrencyUSD } from "@/lib/format";
import type { SKURow } from "@/api/admin/economics";

const cardStyle: CSSProperties = {
  background: "var(--d-ink-2)",
  border: "1px solid var(--d-line)",
  borderRadius: 22,
  padding: 16,
};

const titleStyle: CSSProperties = {
  fontFamily: "var(--font-display)",
  fontSize: 16,
  color: "var(--d-fg)",
  marginBottom: 12,
};

const rowStyle: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  paddingTop: 10,
  paddingBottom: 10,
  borderTop: "1px solid var(--d-line)",
};

const codeStyle: CSSProperties = {
  fontFamily: "var(--font-mono)",
  fontSize: 12,
  letterSpacing: "0.06em",
  color: "var(--d-fg)",
};

const subStyle: CSSProperties = {
  fontFamily: "var(--font-body)",
  fontSize: 11,
  color: "var(--d-fg-dim)",
  marginTop: 2,
};

const valStyle: CSSProperties = {
  fontFamily: "var(--font-mono)",
  fontSize: 14,
  fontVariantNumeric: "tabular-nums",
  color: "var(--d-fg)",
};

export function SKUBreakdown({ rows, locale }: { rows: SKURow[]; locale: string }): JSX.Element {
  const { t } = useTranslation("admin");
  return (
    <div style={cardStyle}>
      <div style={titleStyle}>{t("economics.by_sku.title")}</div>
      {rows.length === 0 ? (
        <div style={subStyle}>{t("economics.by_sku.no_data")}</div>
      ) : (
        rows.map((r) => (
          <div key={r.code} style={rowStyle}>
            <div>
              <div style={codeStyle}>{r.code}</div>
              <div style={subStyle}>
                {t("economics.by_sku.purchases", { count: r.purchases })}
              </div>
            </div>
            <div style={valStyle}>{formatCurrencyUSD(r.revenue_usd, locale)}</div>
          </div>
        ))
      )}
    </div>
  );
}
